import React from 'react';
import Card from '../../ui/Card';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Cell } from 'recharts';
const AdoptionRateChart: React.FC = () => {
  const data = [{
    oem: 'Maruti Suzuki',
    adoptionRate: 24,
    orders: 485,
    color: '#3b82f6'
  }, {
    oem: 'Hyundai',
    adoptionRate: 21,
    orders: 420,
    color: '#10b981'
  }, {
    oem: 'Tata Motors',
    adoptionRate: 19,
    orders: 385,
    color: '#f59e0b'
  }, {
    oem: 'Mahindra',
    adoptionRate: 16,
    orders: 325,
    color: '#8b5cf6'
  }, {
    oem: 'Kia',
    adoptionRate: 14,
    orders: 285,
    color: '#ec4899'
  }, {
    oem: 'Honda',
    adoptionRate: 12,
    orders: 245,
    color: '#06b6d4'
  }, {
    oem: 'Toyota',
    adoptionRate: 11,
    orders: 225,
    color: '#84cc16'
  }, {
    oem: 'VW Group',
    adoptionRate: 9,
    orders: 185,
    color: '#f97316'
  }];
  return <Card className="p-6" data-id="element-6706">
      <h3 className="text-lg font-semibold text-gray-800 mb-2" data-id="element-6707">
        Adoption Rate in OEM Customers
      </h3>
      <p className="text-sm text-gray-600 mb-4" data-id="element-6708">
        New product adoption percentage by OEM
      </p>
      <ResponsiveContainer width="100%" height={300} data-id="element-6709">
        <BarChart data={data} data-id="element-6710">
          <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" data-id="element-6711" />
          <XAxis dataKey="oem" tick={{
          fontSize: 10
        }} angle={-45} textAnchor="end" height={100} data-id="element-6712" />
          <YAxis tick={{
          fontSize: 12
        }} data-id="element-6713" />
          <Tooltip contentStyle={{
          backgroundColor: 'white',
          border: '1px solid #e5e7eb',
          borderRadius: '8px'
        }} formatter={(value: number, name: string) => {
          if (name === 'Adoption Rate') return `${value}%`;
          return value;
        }} data-id="element-6714" />
          <Legend data-id="element-6715" />
          <Bar dataKey="adoptionRate" name="Adoption Rate" radius={[8, 8, 0, 0]} data-id="element-6716">
            {data.map((entry, index) => <Cell key={`cell-${index}`} fill={entry.color} data-id="element-6717" />)}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
      <div className="mt-4 pt-4 border-t border-gray-200" data-id="element-6718">
        <div className="space-y-2" data-id="element-6719">
          {data.slice(0, 4).map((oem, index) => <div key={index} className="flex items-center justify-between text-sm" data-id="element-6720">
              <div className="flex items-center" data-id="element-6721">
                <div className="w-3 h-3 rounded-full mr-2" style={{
              backgroundColor: oem.color
            }} data-id="element-6722" />
                <span className="text-gray-700" data-id="element-6723">{oem.oem}</span>
              </div>
              <div className="flex items-center space-x-4" data-id="element-6724">
                <span className="font-semibold text-gray-900" data-id="element-6725">
                  {oem.adoptionRate}%
                </span>
                <span className="text-gray-600" data-id="element-6726">{oem.orders} orders</span>
              </div>
            </div>)}
        </div>
        <div className="mt-4 pt-4 border-t border-gray-100" data-id="element-6727">
          <div className="flex justify-between text-sm" data-id="element-6728">
            <span className="text-gray-600" data-id="element-6729">Average Adoption Rate</span>
            <span className="font-bold text-green-600" data-id="element-6730">15.8%</span>
          </div>
        </div>
      </div>
    </Card>;
};
export default AdoptionRateChart;